<template>
	<div style="text-align: center">
		<template v-if="scans_for_type === 'rfid'">
			<scanRFIDButton
				:user_name="user_name"
				:credential_title="credential_title"
				:initial_value="initial_value"
				@onScannedRfid="(rfid) => onItemScanned(rfid)"
				ref="scanDecalBtnRef"
			/>
		</template>

		<div v-if="scans_for_type === 'barcode'">
			<scan-qr-button
				:user_name="user_name"
				:credential_title="credential_title"
				:initial_value="initial_value"
				@onScannedQr="(qr) => onItemScanned(qr)"
				ref="scanDecalBtnRef"
			/>
		</div>

		<div v-if="scans_for_type === 'none'">
			<button
				:class="initial_value ? 'grey-background' : ''"
				@click="onItemScanned('none')"
				class="better-mobile-btn">
				Given
			</button>
		</div>

		<ErrorPopup
			:show="shouldShowError"
			:error-message="errorMessage"
			@close="closeError"
		/>
	</div>
</template>

<script>
import ScanRFIDButton from "./ScanRFIDButton.vue";
import ScanQrButton from "@/components/ScanQrButton.vue";
import ErrorPopup from "@/components/ErrorPopup.vue";
import axios from "axios";

export default {
	name: 'ScanCredentials',
	components: {
		ScanQrButton,
		ScanRFIDButton,
		ErrorPopup
	},
	props: {
		party_id: {
			type: Number,
			required: true
		},
		user_name: {
			type: String,
			required: true
		},
		party_item_id: {
			type: Number,
			required: true
		},
		credential_title: {
			type: String,
			required: true
		},
		scans_for_type: {
			type: String,
			required: true
		},
		initial_value: {
			type: String,
			default: ""
		},
	},
	data() {
		return {
			partyItemsToProcess: [],
			partyUsers: [],
			scannedValue: "",
			shouldShowError: false,
			errorMessage: "test",
			errorBtnText: "",
		}
	},
	methods: {
		onItemScanned(value) {
			this.disbursePartyItem(value)
			this.scannedValue = value
		},
		disbursePartyItem(value) {
			window.scanner.loader.open()

			const scannerRegKey = localStorage.getItem('scanner_regkey');
			axios.defaults.headers.common['X-Auth-Token'] = scannerRegKey;
			axios.post(`${this.$scanner.api_server}/api/scannerdevice/party/${this.party_id}/disbursePartyItem`, {
				check: scannerRegKey,
				party_item_id: this.party_item_id,
				barcode_or_rfid: value,
			})
				.then(res => {
					this.$emit('onCredentialScanned', this.scannedValue);
				})
				.catch(err => {
					if (err.response !== undefined && err.response.status === 422) {
						this.$refs.scanDecalBtnRef.startScanning()
						this.errorMessage = Object.values(err.response.data.errors).join("\n\n")
						this.shouldShowError = true
					} else if (err.response !== undefined && err.response.status === 417) {
						this.shouldShowError = true
						this.errorMessage = err.response.data.message
					} else {
						// non 422 is uh oh time
						this.shouldShowError = true
						this.errorMessage = 'Big time Error, contact champion support'
					}
				})
				.finally(() => {
					window.scanner.loader.close()
				})
		},
		closeError() {
			this.shouldShowError = false
		}
	}
}
</script>

<style scoped>
.flex {
	display: flex;
	justify-content: space-between;
}

.grey-background {
	background: #666 !important;
}
</style>